


@if (showLoader()) {
  <app-loader />
} @else {
  <router-outlet />
}

